import React, { useState, useEffect } from "react";
import metrics from "../helpersjson/Metrics.json";
import icon1 from "../assets/img/marketplace/1.png";
import icon2 from "../assets/img/marketplace/2.png";
import icon3 from "../assets/img/marketplace/3.png";
import icon4 from "../assets/img/marketplace/4.png";
import icon5 from "../assets/img/marketplace/5.png";
import icon6 from "../assets/img/marketplace/5.png";
import imagePng from "../assets/img/Group 1000004857.png";
import { Link, useNavigate } from "react-router-dom";
import { FaPlus, FaSave } from "react-icons/fa";
import { TfiAngleLeft } from "react-icons/tfi";
import { BsThreeDots } from "react-icons/bs";
import { MdEdit } from "react-icons/md";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import Select from "react-select";
import Api from "../api/api";
import { Value } from "sass";
import colorsData from "../Colors.json";
import LineChart from "../components/dashbaord/Linechart";
import { LiaAngleLeftSolid } from "react-icons/lia";
import FormBox from "../components/FormBox";
import brokerjson from "../services/Helpers/BrokerFields.json";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import Aesfile from '../services/Utils/aes.js';
const iconMap = {
  icon1: icon1,
  icon2: icon2,
  icon3: icon3,
  icon4: icon4,
  icon5: icon5,
  icon6: icon6,
};
function AboutStrategies({ setShowAbtStr, data }) {
  const location = useLocation();
  const sharedData = location.state?.data || data;
  const navigate = useNavigate();
  const [value, setValue] = useState(sharedData.strategy_desc);
  const [edit, setedit] = useState(false);
  const [editTags, seteditTags] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [tags, setTags] = useState(sharedData?.tags);
  const [modal, setmodal] = useState(false);
  const [subscribeModal, setsubscribeModal] = useState(false);
  const [brokers, setBrokers] = useState([]);
  const [chartDatas, setchartData] = useState([])
  const [selectedAction, setselectedAction] = useState("Back Testing");
  const colors = colorsData.colors;
  const option = [
    { value: "Nifty", label: "Nifty" },
    { value: "Bse", label: "Bse" },
    { value: "Money Bager", label: "Money Bager" },
    { value: "Cobra", label: "Cobra" },
  ];
  const options = Object.keys(brokerjson).map((key) => ({
    value: key,
    label: key,
  }));
  const MenuItems = [
    { link: "Back Testing" },
    { link: "Live Runs" },
    { link: "Results" },
    // Publish Strategy flow commented out - not accessible
    // { link: "Publish Strategy" },
    { link: "Delete" },
  ];
  const intervalDatas = [
    { value: "1_min", label: "1 min" },
    { value: "5_mins", label: "5 mins" },
    { value: "15_mins", label: "15 mins" },
    { value: "1_hr", label: "1 hr" },
  ];
  const [strategyValue, setStrategyValue] = useState({
    start_date: "",
    end_date: "",
    publish_id: "",
  });
  const [values, setValues] = useState({
    // broker_name: "",
    broker_id: null,
    start_date: "",
    end_date: "",
    strategy_id: "",
    interval: "",
    user_id: JSON.parse(localStorage.getItem("user_details")).user_id,
    run_type: "paper"
  });

  const handleSelectSubscribeChange = (fieldName, fieldValue) => {
    setStrategyValue((prevState) => ({
      ...prevState,
      [fieldName]: fieldValue,
    }));
  };
  const handleSelectChange = (fieldName, fieldValue) => {
    setValues((prevState) => ({
      ...prevState,
      [fieldName]: fieldValue,
    }));
  };

  async function getrunschart() {
    const payload = {
      run_id: sharedData?.run_id,
      run_type: sharedData?.run_type
    };
    try {
      let res = await Api.runresults(payload);
      setchartData(res.data.chart_data);
    } catch (error) {
      alert("Error while fetching Strategies");
    }
  }

  const handleTagSelectChange = (selected) => {
    const selectedValues = selected?.map((item) => item.value);
    setTags(selectedValues);
    handleupdatestrategy({
      strategy_id: data.strategy_id,
      tags: selectedValues,
    });
    setSelectedOptions(selected);
  };

  async function getBrokers() {
    try {
      let res = await Api.brokers();
      //setBrokers(res?.data);
      var res1 = await Aesfile.decryptPayload(res.data);
      setBrokers(
        res1.map((broker) => ({
          broker_id: broker.broker_id,
          value: broker.broker_name + "-" + broker.username,
          label: broker.broker_name + "-" + broker.username,
        }))
      );
    } catch (error) {
      alert("Error while fetching Strategies");
    }
  }

  async function strategy(data) {
    try {
      // Validation for required fields based on selected action
      const requiredFields = [];
      
      // Common required fields for all actions
      if (!values.strategy_id) requiredFields.push("Strategy ID");
      if (!values.start_date) requiredFields.push("Start Date");
      if (!values.end_date) requiredFields.push("End Date");
      
      // Additional validation for non-publish actions
      if (selectedAction !== "Publish Strategy") {
        if (!values.broker_id) requiredFields.push("Broker");
        if (!values.interval) requiredFields.push("Interval");
      }
      
      // Additional validation for Live Runs
      if (selectedAction === "Live Runs") {
        if (!values.run_type) requiredFields.push("Run Type");
      }
      
      // Additional validation for Publish Strategy
      if (selectedAction === "Publish Strategy") {
        if (!value || value.trim() === "" || value === "<p><br></p>") {
          requiredFields.push("Strategy Description");
        }
        if (!chartDatas || chartDatas.length === 0) {
          requiredFields.push("Please run backtesting to publish this strategy");
        }
      }
      
      // Check if any required fields are missing
      if (requiredFields.length > 0) {
        toast.error(`Please fill in the following required fields: ${requiredFields.join(", ")}`);
        return;
      }
      
      // Validate date range
      if (values.start_date && values.end_date) {
        const startDate = new Date(values.start_date);
        const endDate = new Date(values.end_date);
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to start of day
        
        if (startDate >= endDate) {
          toast.error("End date must be after start date");
          return;
        }
        
        // For Back Testing, ensure no future dates are selected
        if (selectedAction === "Back Testing") {
          if (startDate > today) {
            toast.error("Start date cannot be in the future for Back Testing");
            return;
          }
          if (endDate > today) {
            toast.error("End date cannot be in the future for Back Testing");
            return;
          }
        }
      }
      
      const Payload = {
        strategy_id: values.strategy_id,
        start_date: values.start_date,
        end_date: values.end_date,
      };
      let res;
      if (selectedAction === "Publish Strategy") {
        res = await Api.publishStrategy(Payload);
      } else if (selectedAction === "Back Testing") {
        res = await Api.backtestStrategy(values);
      } else if (selectedAction === "Live Runs") {
        res = await Api.liveRunStrategy(values);
      }
      setmodal(false);
      setValues({
        broker_id: 0,
        start_date: "",
        end_date: "",
        strategy_id: "",
        interval: "",
        run_type: "paper"
      });
      toast.success(res?.message)
    } catch (error) {
      console.log(error);
      toast.error("An error occurred while processing the request");
    }
  }

  const submitmodal = () => {
    strategy();
  };
  const closeModal = () => {
    setmodal(false);
    setValues({
      broker_id: 0,
      start_date: "",
      end_date: "",
      strategy_id: "",
    });
  };
  const calculateDate = (offsetDays) => {
    const today = new Date();
    today.setDate(today.getDate() + offsetDays);
    return today.toISOString().split("T")[0];
  };
  useEffect(() => {
    const initialSelectedOptions = tags?.map((tag) => ({
      value: tag,
      label: tag,
    }));
    setSelectedOptions(initialSelectedOptions);
  }, [tags]);

  const handleBackClick = () => {
    if (setShowAbtStr) {
      setShowAbtStr();
    } else navigate('/dashboard')

  };
  useEffect(() => {
    getrunschart()
    getBrokers();
  }, []);

  // Keyboard navigation handlers
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Don't trigger if user is typing in an input field
      const isInputFocused = e.target.tagName === 'INPUT' || 
                            e.target.tagName === 'TEXTAREA' ||
                            e.target.isContentEditable;
      
      // Backspace key - go back (only when not in input)
      if (e.key === 'Backspace' && !isInputFocused) {
        // Check if we're at the top of the page to avoid browser back navigation
        if (window.scrollY === 0) {
          e.preventDefault();
          handleBackClick();
        }
      }
      
      // Escape key - go back
      if (e.key === 'Escape' && !isInputFocused) {
        e.preventDefault();
        handleBackClick();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);

  async function handleupdatestrategy(data) {
    try {
      let res = await Api.strategyUpdate(data);
      // setIsEdit(false);
      // getProfile();
    } catch (error) {
      console.log(error);
    }
  }
  async function subscribeApi() {
    try {
      let res = await Api.subscribeStrategy(strategyValue);
      setsubscribeModal(false);
      setStrategyValue({
        start_date: "",
        end_date: "",
        publish_id: "",
      });
      toast.success(res?.message)
    } catch (error) {
      console.log(error);
    }
  }

  async function deleteStrategy() {
    try {
      const payload = {
        strategy_id: sharedData?.strategy_id
      };
      let res = await Api.deleteStrategy(payload);
      toast.success(res?.message || "Strategy deleted successfully");
      // Navigate back to strategies list or dashboard
      setTimeout(() => {
        // Try multiple navigation methods to ensure it works
        try {
          navigate('/strategies');
        } catch (navError) {
          console.log('Navigate failed, trying window.location:', navError);
          window.location.href = '/strategies';
        }
      }, 1000); // Small delay to ensure toast is shown
    } catch (error) {
      console.log(error);
      toast.error("Failed to delete strategy");
    }
  }

  const submitSubscribemodal = () => {
    subscribeApi();
  };

  const closeSubscribeModal = () => {
    setsubscribeModal(false);
    setStrategyValue({
      start_date: "",
      end_date: "",
      publish_id: "",
    });
  };

  useEffect(() => {
    if (sharedData.dashboard) {
      handleSelectSubscribeChange("publish_id", sharedData?.publish_id)
      setsubscribeModal(!subscribeModal)
    }
  }, [sharedData.dashboard])

  const SubscribeModal = () => {
    return (
      <div
        className={`login-otp align-items-center justify-content-center p-3 position-fixed top-0 start-0 w-100 z-2 bg-black bg-opacity-20 h-100 ${subscribeModal ? "d-flex" : "d-none"
          }`}
      >
        <div className="login-otp-wrap bg-white p-3 p-md-4 rounded-4">
          <div className="login-popup-header d-flex align-items-center gap-2 mb-3 pb-md-1">
            <button
              className="login-close text-body d-flex align-items-center justify-content-center rounded-pill border-0 p-0"
              onClick={closeSubscribeModal}
            >
              <LiaAngleLeftSolid />
            </button>
            <h4 className="mb-0">Subscribe</h4>
          </div>
          <FormBox
            className="mb-3"
            type="date"
            label="From"
            placeholder="mm/dd/yyyy"
            min={calculateDate(0)}
            max={null}
            value={strategyValue.start_date}
            onChange={(event) =>
              handleSelectSubscribeChange("start_date", event.target.value)
            }
          />
          <FormBox
            className="mb-3"
            type="date"
            label="To"
            placeholder="mm/dd/yyyy"
            min={calculateDate(0)}
            max={null}
            value={strategyValue.end_date}
            onChange={(event) =>
              handleSelectSubscribeChange("end_date", event.target.value)
            }
          />
          <button
            className="btn w-100 fs-14 mb-3 my-3 mt-5"
            style={{ marginTop: "50px" }}
            onClick={closeSubscribeModal}
          >
            Cancel
          </button>

          <button className="btn bg-primary w-100 fs-14" onClick={submitSubscribemodal}>
            Subscribe
          </button>
        </div>
      </div>
    );
  };
  const DynamicModal = () => {
    return (
      <div
        className={`login-otp align-items-center justify-content-center p-3 position-fixed top-0 start-0 w-100 z-2 bg-black bg-opacity-20 h-100 ${modal ? "d-flex" : "d-none"
          }`}
      >
        <div className="login-otp-wrap bg-white p-3 p-md-4 rounded-4">
          <div className="login-popup-header d-flex align-items-center gap-2 mb-3 pb-md-1">
            <button
              className="login-close text-body d-flex align-items-center justify-content-center rounded-pill border-0 p-0"
              onClick={closeModal}
            >
              <LiaAngleLeftSolid />
            </button>
            <h4 className="mb-0">{selectedAction}</h4>
          </div>

          {selectedAction !== "Publish Strategy" && (
            <>
              {" "}
              <label className="text-dark py-2">Select Broker</label>
              <Select
                className="mb-3"
                name="broker_id"
                options={brokers}
                value={
                  brokers.find(
                    (option) => option.broker_id === values.broker_id
                  ) || ""
                }
                onChange={(selectedOption) => {
                  handleSelectChange(
                    "broker_id",
                    selectedOption ? selectedOption.broker_id : 0
                  );
                }
                }
                placeholder="Select Broker"
                label="Select Broker"
              />
            </>
          )}

          {selectedAction === "Live Runs" && (
            <div className="mb-3">
              <label className="text-dark py-2">Run Type</label>
              <div className="d-flex gap-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="run_type"
                    id="paper_test"
                    value="paper"
                    checked={values.run_type === "paper"}
                    onChange={(e) => handleSelectChange("run_type", e.target.value)}
                    style={{ padding: "0px" }}
                  />
                  <label className="form-check-label" htmlFor="paper_test">
                    Paper Test
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="run_type"
                    id="live_orders"
                    value="live"
                    checked={values.run_type === "live"}
                    onChange={(e) => handleSelectChange("run_type", e.target.value)}
                    style={{ padding: "0px" }}
                  />
                  <label className="form-check-label" htmlFor="live_orders">
                    Live Orders
                  </label>
                </div>
              </div>
            </div>
          )}

          <FormBox
            className="mb-3"
            type="date"
            label="From"
            placeholder="mm/dd/yyyy"
            min={
              selectedAction === "Back Testing"
                ? calculateDate(-90)
                : calculateDate(0)
            }
            max={null}
            value={values.start_date}
            onChange={(event) => {
              const selectedDate = new Date(event.target.value);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              
              if (selectedAction === "Back Testing") {
                // Check if date is in the future
                if (selectedDate > today) {
                  toast.error("Start date cannot be in the future for Back Testing");
                  return;
                }
                
                // Check if date is more than 90 days ago
                const minDate = new Date();
                minDate.setDate(today.getDate() - 90);
                if (selectedDate < minDate) {
                  toast.error("Start date cannot be more than 90 days ago for Back Testing");
                  return;
                }
              }
              
              handleSelectChange("start_date", event.target.value);
            }}
          />
          <FormBox
            className="mb-3"
            type="date"
            label="To"
            placeholder="mm/dd/yyyy"
            min={
              selectedAction === "Back Testing"
                ? calculateDate(-90)
                : calculateDate(0)
            }
            max={null}
            value={values.end_date}
            onChange={(event) => {
              const selectedDate = new Date(event.target.value);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              
              if (selectedAction === "Back Testing" && selectedDate > today) {
                toast.error("End date cannot be in the future for Back Testing");
                return;
              }
              
              handleSelectChange("end_date", event.target.value);
            }}
          />
          {selectedAction !== "Publish Strategy" && (
            <>
              {" "}
              <label className="text-dark py-2">Select Interval</label>
              <Select
                className="mb-3"
                name="interval"
                options={intervalDatas}
                value={
                  intervalDatas.find(
                    (option) => option.value === values.interval
                  ) || ""
                }
                onChange={(selectedOption) =>
                  handleSelectChange(
                    "interval",
                    selectedOption ? selectedOption.value : ""
                  )
                }
                placeholder="Select Interval"
                label="Select Interval"
              />
            </>
          )}
          <button
            className="btn w-100 fs-14 mb-3 my-3 mt-5"
            style={{ marginTop: "50px" }}
            onClick={closeModal}
          >
            Cancel
          </button>

          <button className="btn bg-primary w-100 fs-14" onClick={submitmodal}>
            {selectedAction}
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="dashboard-wrap  aboutstrategy">
        <div className="profile-profit strategies bg-white">
          <div className="strategies-detail-header d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              <span
                onClick={handleBackClick}
                className="icon d-flex align-items-center justify-content-center cursor-pointer"
              >
                <TfiAngleLeft />
              </span>
              <div className="text ">
                <h4 className="fw-semibold lh-base text-heading m-0">
                  {sharedData.strategy_name}
                </h4>
                {sharedData.published_user && (
                  <p className="fs-14 lh-base fw-medium mt-1">
                    By:{" "}
                    
                      {sharedData.published_user}
                    
                  </p>
                )}
              </div>
            </div>
            <div className="strategies-btn d-flex align-items-center gap-2">
              <div className="btn-wrap d-flex align-items-center gap-2">
                {!sharedData.published_user && sharedData.publish_id == 0 && (
                  <Link
                    to={`/create-strategies?strategy=${sharedData?.strategy_id}`}
                    className="text-center fs-14 font-medium btn bg-primary"
                  >
                    <MdEdit />
                    Edit
                  </Link>
                )}
                {(sharedData?.is_subscribed === "N" && (sharedData?.marketplace || sharedData?.dashboard)) ? (
                  <button className="text-center fs-14 font-medium btn bg-primary" onClick={() => { handleSelectSubscribeChange("publish_id", sharedData?.publish_id); setsubscribeModal(!subscribeModal) }}>
                    Subscribe
                  </button>
                )
                  :
                  <>
                    {MenuItems.map((items) => {
                      // Only show "Publish Strategy" button if user is the published user
                      if (items.link === "Publish Strategy" && (sharedData?.is_subscribed === "Y"|| sharedData?.is_subscribed === "P" ||sharedData.published_user||sharedData.publish_id != 0)) {
                        return null;
                      }
                      
                      // Only show "Delete" button if user is the owner (not published user)
                      if (items.link === "Delete" && (sharedData.published_user || sharedData.publish_id != 0)) {
                        return null;
                      }
                      
                      return (
                        <button
                          key={items.link}
                          className={`text-center fs-14 font-medium btn ${
                            items.link === "Delete" ? "btn-outline-danger" : "btn-outline-primary"
                          }`}
                          onClick={() => {
                            if (items.link === "Delete") {
                              if (window.confirm("Are you sure you want to delete this strategy? This action cannot be undone.")) {
                                deleteStrategy();
                              }
                            } else {
                              setValues((prevState) => ({
                                ...prevState,
                                strategy_id: sharedData?.strategy_id,
                              }));
                              setselectedAction(items.link);
                              if (items.link === "Results") {
                                navigate("/result", { state: { data: sharedData } });
                              } else {
                                setmodal(true);
                              }
                            }
                          }}
                        >
                          {items.link}
                        </button>
                      );
                    })}
                  </>
                }
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12 mb-2">
            <div className="mt-1">
              <div className="d-flex align-items-center gap-2 mb-2">
                <div className="fw-semibold lh-base text-heading">
                  Strategy Tags
                </div>
                
                {!sharedData.published_user && (
                  <div className="cursor-pointer">
                    {!editTags ? (
                      <span onClick={() => seteditTags(!editTags)}>
                        <MdEdit />
                      </span>
                    ) : (
                      <span onClick={() => seteditTags(!editTags)}>
                        <FaSave />
                      </span>
                    )}
                  </div>
                )}
                
                {editTags && (
                  <div className="flex-grow-1">
                    <Select className="text-start"
                      isMulti
                      options={option}
                      value={selectedOptions}
                      onChange={handleTagSelectChange}
                    />
                  </div>
                )}
              </div>
              
              {!editTags && (
                <div className="d-flex mb-4">
                  {tags?.map((item, index) => (
                    <span
                      className="mx-1 px-2 py-1"
                      style={{
                        borderColor: "#F8F8F8",
                        backgroundColor: colors[index % colors.length],
                        color: "#151B22",
                        fontSize: "14px",
                        borderRadius: "8px",
                      }}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              )}
            </div>

              {/* <img src={imagePng} className="w-100" /> */}
              {chartDatas && chartDatas.length > 0 && (
                <LineChart chartdata={chartDatas} borderColor={"#5ed9bf"} />)}
              <div className="all-valurss-history mb-3 mt-4 mx-auto row metricsabout">
                {metrics?.metrics?.map((itm, iddx) => (
                  <div className="col-6 col-md-6 col-lg-6 mb-2" key={iddx}>
                    <div
                      className="total-value h-100 d-flex align-items-center gap-2 p-2"
                      style={{
                        backgroundColor: "#F8F8F8",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="image-area">
                        <img src={iconMap[itm.icon]} alt="" />
                      </div>
                      <div className="values">
                        <p className="mb-1 price fs-6 fw-semibold">
                          {sharedData.metrics[itm.key] ? sharedData.metrics[itm.key] : 0}
                        </p>
                        <p className="fs-14">{itm.title}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-6 col-12 mb-2">
              <div className="d-flex align-items-center gap-2 mt-2 ">
                <div className="fw-semibold lh-base text-heading">
                  Strategy Description
                </div>
                {!sharedData.published_user && (
                  <div className="cursor-pointer">
                    {edit ? (
                      <span
                        onClick={() => {
                          setedit(!edit);
                          handleupdatestrategy({
                            strategy_id: sharedData.strategy_id,
                            strategy_desc: value,
                          });
                        }}
                      >
                        <FaSave />
                      </span>
                    ) : (
                      <span onClick={() => setedit(!edit)}>
                        <MdEdit />
                      </span>
                    )}
                  </div>
                )}
              </div>
              {edit ? (
                <ReactQuill theme="snow" value={value} onChange={setValue} />
              ) : (
                <div className="ps-3" dangerouslySetInnerHTML={{ __html: value }} style={{ wordWrap: "break-word" }} />
              )}
            </div>
          </div>
        </div>
        {modal && <DynamicModal />}
        {subscribeModal && <SubscribeModal />}
      </div>
    </>
  );
}

export default AboutStrategies;
